﻿<script setup lang="ts">
import {ref} from 'vue';
import {useQuasar} from 'quasar';
import {useRouter} from 'vue-router';
import {useI18n} from 'vue-i18n';
import {handleApiRequest} from 'src/api/handleApiRequest';
import {getNextActivationRoute, PIQSetupPages} from '@/services/piqSetupService.ts';
import MultiViewLayout from 'src/components/layouts/MultiViewLayout.vue';

import TheAbandonModal from '@/components/TheAbandonModal.vue';

const showAbandon = ref(false);

async function onAbandonClick() {
  showAbandon.value = !showAbandon.value;
}

import TheContactModal from '@/components/TheContactModal.vue';
import {updateHBSVersion} from '@/api/endpoints/patientWeb.ts';

const showContact = ref(false);

async function onInfoClick() {
  showContact.value = !showContact.value;
}

const $q = useQuasar()
const router = useRouter();
const {t} = useI18n();

const enum versionEnum {
  v1 = 'v1',
  v2 = 'v2'
}

const selectedVersion = ref(null);

async function onNextClick() {
  const response = await handleApiRequest(() => updateHBSVersion(selectedVersion.value), null, $q);
  if (response?.result) {
    const nextRoute = await getNextActivationRoute($q);
    router.push({
      name: nextRoute
    }).catch(() => {});
  }
}

function handleTypeClick(type: versionEnum) {
  selectedVersion.value = selectedVersion.value == versionEnum[type] ? null : versionEnum[type];
}

</script>

<template>
  <q-page padding class="canary setup select">
    <MultiViewLayout :onBackClick="onAbandonClick" back-icon-list="fa-solid fa-house-circle-xmark"
                      >
      <template v-slot:title>
        {{ t('hbs_flow_title') }}
      </template>

      <!-- Title -->
      <template #heading>
        {{ t('hbs_hwselect_title') }}
      </template>

      <template v-slot:auxiliary>
        <zbm-btn-icon @click="onInfoClick()" icon="fa-regular fa-question-circle" size="24px" text-color="dark-teal"/>
      </template>
      <!-- View Unique Content -->
      <template #default>
        <div class="row">
          <div class="col-12">
            <p>
              {{ t('hbs_hwselect_body') }} </p>
          </div>

          <div class="col-12">
            <div class="row pt-40 justify-between q-gutter-md">
              <div class="col bs_selector"
                   :class="selectedVersion == versionEnum.v1? 'active': ''"
                   @click="handleTypeClick(versionEnum.v1)">
                <img src="img/baseStation/BSI-Y.svg" alt=""/>
                <p class="semibold">
                  {{ t('hbs_hwselect_label_hbs1') }} </p>
              </div>

              <div class="col bs_selector"
                   :class="selectedVersion == versionEnum.v2? 'active': ''"
                   @click="handleTypeClick(versionEnum.v2)">
                <img src="img/baseStation/BSI-W.svg" alt=""/>
                <p class="semibold">
                  {{ t('hbs_hwselect_label_hbs2') }} </p>
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="row pt-16" style="min-height: 89px">
              <div  v-if="selectedVersion!= null" class="selection-msg bg-primitives-foundation-10 p-10-20 radius-md">
                <p v-if="selectedVersion== 'v1'" v-html="t('hbs_hwselect_summary_hbs1')"></p>
                <p v-if="selectedVersion == 'v2'" v-html="t('hbs_hwselect_summary_hbs2')"></p>
              </div>
            </div>
          </div>

          <div class="col-12 self-end text-center">
            <div v-if="selectedVersion== null" class="row pt-48">
              <zbm-btn :color="$zb.enums.ButtonStdColorEnum.whiteText" :label="t('hbs_hwselect_button_abandon')"
                       :outline="true" :width="$zb.enums.ButtonWidthEnum.wFull" :height="$zb.enums.ButtonHeightEnum.lg"
                       :disabled="!selectedVersion==null" @click="onAbandonClick"/>

            </div>
            <div v-else class="row pt-48">
              <zbm-btn :color="$zb.enums.ButtonStdColorEnum.accent" :label="t('acc_gen_continue')" :outline="true"
                       :width="$zb.enums.ButtonWidthEnum.wFull" :height="$zb.enums.ButtonHeightEnum.lg"
                       :disabled="!selectedVersion==null" @click="onNextClick"/>
            </div>

          </div>
        </div>

      </template>
    </MultiViewLayout>
    <the-abandon-modal v-model="showAbandon"/>

    <the-contact-modal v-model="showContact"/>
  </q-page>
</template>

<style scoped lang="scss">

</style>
